module.exports = __webpack_public_path__ + "static/media/color_blind_image_4.c98a08d7.jpg";